module.exports = __webpack_public_path__ + "img/my-tokens-table.4110c35b.png";